const numericStyles = { '&[data-is-numeric=true]': { textAlign: 'end' } };

export default {
  variants: {
    base: {
      table: {},
      thead: {
        position: 'sticky',
        top: 0,
        h: 5,
        bgColor: 'green.800',
        zIndex: 20,
      },
      th: {
        ...numericStyles,
        px: 1,
        py: 1,
        fontSize: { base: '3xs', md: 'xs' },
        lineHeight: 1,
        textAlign: 'end',
        color: 'white.900',
        // Per-cell sticky + opaque background on every <Th>.
        // Applying sticky to the individual cells (not just to <thead>) is the most
        // reliable cross-browser technique: each cell independently covers the scroll
        // position, eliminating the sub-pixel transparent gap that can appear when only
        // the <thead> element is sticky.
        // top: -1px extends each cell 1 px above the scroll viewport, sealing the
        // sub-pixel gap where row text can otherwise bleed through the header edge.
        position: 'sticky',
        top: '-1px',
        bgColor: 'green.800',
        _first: {
          position: 'sticky',
          // top + left on the same element produces a true frozen corner.
          // top: -1px matches the other th cells so the corner seals the same gap.
          top: '-1px',
          left: 0,
          bgColor: 'green.800',
          zIndex: 10,
        },
      },
      tbody: {
        bgColor: 'white.900',
        tr: {
          position: 'relative',
          _notLast: {
            borderBottomWidth: 1,
            borderBottomColor: 'grey.800',
          },
          _last: { h: 7 },
        },
      },
      td: {
        ...numericStyles,
        p: 1,
        fontSize: { base: '3xs', md: 'xs' },
        lineHeight: 1,
        textAlign: 'end',
        color: 'black.900',
        _first: {
          position: 'sticky',
          left: 0,
          textAlign: 'start',
          cursor: 'pointer',
          bgColor: 'white.900',
          bgClip: 'padding-box',
          pr: '2',
          minWidth: '100px',
        },
      },
    },
    // Same layout/sticky behavior as `base`, but with the header bar recolored to
    // match the dashboard's light/purple theme instead of the app-wide dark green.
    dashboardV2: {
      table: {},
      thead: {
        position: 'sticky',
        top: 0,
        h: 5,
        zIndex: 20,
      },
      th: {
        ...numericStyles,
        px: 1,
        py: 1,
        fontSize: { base: '3xs', md: 'xs' },
        lineHeight: 1,
        textAlign: 'end',
        color: '#121826',
        position: 'sticky',
        top: '-1px',
        borderBottom: '1px solid',
        borderBottomColor: '#E4D5FC',
        _first: {
          position: 'sticky',
          top: '-1px',
          left: 0,
          zIndex: 10,
          textAlign: 'start',
        },
      },
      tbody: {
        bgColor: 'white',
        tr: {
          position: 'relative',
          _notLast: {
            borderBottomWidth: 1,
            borderBottomColor: '#E4D5FC',
          },
          _last: { h: 7 },
        },
      },
      td: {
        ...numericStyles,
        p: 1,
        fontSize: { base: '3xs', md: 'xs' },
        lineHeight: 1,
        textAlign: 'end',
        color: '#121826',
        _first: {
          position: 'sticky',
          left: 0,
          textAlign: 'start',
          cursor: 'pointer',
          bgColor: 'white',
          bgClip: 'padding-box',
          pr: '2',
          minWidth: '100px',
        },
      },
    },
    dimension: {
      thead: {
        position: 'sticky',
        top: 0,
        bgColor: '#F5F0FF',
        borderBottom: '1px solid',
        borderBottomColor: '#E4D5FC',
      },
      th: {
        px: 0,
        py: 3,
        fontFamily: 'bold_roboto',
        fontSize: '2xs',
        lineHeight: 4,
        textTransform: 'none',
        color: '#121826',
        _last: { textAlign: 'end' },
      },
      tbody: {
        tr: {
          borderBottomWidth: 1,
          borderBottomColor: '#E4D5FC',
          _hover: {
            td: {
              _first: {
                '& .pc_icon': {
                  opacity: 1,
                  _hover: {
                    fill: '#8B5CF6',
                    cursor: 'pointer',
                  },
                },
              },
            },
          },
        },
        td: {
          px: 0,
          py: 2.5,
          fontFamily: 'regular_roboto',
          fontSize: '2xs',
          lineHeight: 3,
          textTransform: 'none',
          color: '#121826',
          _first: {
            '& .pc_icon': {
              opacity: 0,
              fill: '#8B5CF6',
            },
            '& .mobile_icon': {
              opacity: 1,
              fill: '#8B5CF6',
            },
          },
          _last: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          },
        },
      },
    },
  },
  defaultProps: { variant: 'base' },
};
